/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { useIntl } from "react-intl"
import {
  Box,
  BoxProps,
  CloseIcon,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogProps,
  Divider,
  IconButton
} from "@carrotfertility/carotene-core"

interface CarrotPlansTourModalProps extends Omit<DialogProps, "onClose"> {
  onClose: (props: unknown) => unknown
}

function TourImage(props: BoxProps<"img">) {
  return (
    <Box
      alt=""
      marginBottom={(theme) => theme.spacing(theme.tokens.spacing.lg)}
      component="img"
      borderRadius={(theme) => theme.tokens.borderRadius.md}
      {...props}
    />
  )
}

export default function CarrotPlansTourModal({ onClose, ...otherProps }: CarrotPlansTourModalProps): JSX.Element {
  const intl = useIntl()

  // This should default to en-US if the locale is not supported
  const { locale } = intl

  return (
    <Dialog aria-labelledby="cp-tour-modal-title" onClose={onClose} {...otherProps}>
      <Box display="flex" justifyContent="flex-end">
        <IconButton aria-label={intl.formatMessage({ defaultMessage: "Close" })} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent
        sx={{ display: "flex", gap: (theme) => theme.spacing(theme.tokens.spacing.md), flexDirection: "column" }}
      >
        <DialogContentText
          id="cp-tour-modal-title"
          component="h2"
          variant="h2"
          paddingBottom={(theme) => theme.spacing(theme.tokens.spacing.xs)}
        >
          {intl.formatMessage({ defaultMessage: "How to use Carrot Plans" })}
        </DialogContentText>
        <DialogContentText>
          {intl.formatMessage({
            defaultMessage:
              "Your Carrot Plan is your Care Team's top suggestions for you right now. Click any item with an orange arrow to take action:"
          })}
        </DialogContentText>
        <TourImage src={`/images/carrot-plans/${locale}-unchecked-menu-item.jpg`} />
        <Divider role="none" />
        <DialogContentText>
          {intl.formatMessage({ defaultMessage: "Check items off to let us know you've completed them:" })}
        </DialogContentText>
        <TourImage src={`/images/carrot-plans/${locale}-checked-menu-item.jpg`} />
        <Divider role="none" />
        <DialogContentText>
          {intl.formatMessage({
            defaultMessage: "Click the three dots on the right to tell us if something doesn't feel relevant:"
          })}
        </DialogContentText>
        <TourImage src={`/images/carrot-plans/${locale}-not-relevant.jpg`} />
      </DialogContent>
    </Dialog>
  )
}
